// actions.ts

// Action Types
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";
export const UPDATE_STATE = "updateState";


export const logout = () => ({
    type: LOGOUT,
});

export const updateState = (payload: Partial<any>) => ({
    type: UPDATE_STATE,
    payload,
});
